module.exports = __webpack_public_path__ + "img/6.a41b63ac.jpg";